import {AuthApiClient} from "./AuthApiClient";
import {CheckProviderRequest, CheckProviderResponse, SigninRequest, SessionDataResponse} from "./dtos";

export class FetchAuthApiClient implements AuthApiClient {
    private baseUrl = '/api/auth';

    async checkProvider(request: CheckProviderRequest): Promise<CheckProviderResponse> {
        const response = await fetch(`${this.baseUrl}/check-provider`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error(`API error: ${response.statusText}`);
        }

        return await response.json() as CheckProviderResponse;
    }

    async signin(request: SigninRequest): Promise<void> {
        const response = await fetch(`${this.baseUrl}/signin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error(`API error: ${response.statusText}`);
        }
    }

    initiateOAuthSignin(provider: string): void {
        window.location.href = `${this.baseUrl}/oidc/${provider}`;
    }

    async getSessionData(): Promise<SessionDataResponse> {
        const response = await fetch(`${this.baseUrl}/session`);

        if (!response.ok) {
            throw new Error(`API error: ${response.statusText}`);
        }

        return await response.json() as SessionDataResponse;
    }

    async signout(): Promise<void> {
        const response = await fetch(`${this.baseUrl}/signout`, {
            method: 'GET',
        });

        // Wyczyść cookie ds-wam-session
        document.cookie = 'ds-wam-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

        // Sprawdź czy odpowiedź zawiera status code redirectu (3xx) i nagłówek Location
        if (response.status >= 300 && response.status < 400) {
            const location = response.headers.get('Location');
            if (location) {
                await fetch(location, {
                    method: 'GET',
                });
                return;
            }
        }
    }
}

